import styles from "./RecuperarSenha.module.scss";
import { Input } from "shared/components/inputs/Input";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import { Lock } from "lucide-react";
import { cognitoResetPassword,} from "shared/services/aws/cognito";

const schema = z.object({ email: z
    .string()
    .email("Insira um email válido")
    .min(1, "O campo é obrigatório"),
    codigo: z.string().optional(),
});

type FormData = z.infer<typeof schema>;

export const RecuperarSenha = () => {
  const navigate = useNavigate();
  const [loading, setLoading] =  useState(false);
  const [erro, setErro] =  useState("");
  const [emailEnviado, setEmailEnviado] = useState(false);
  const [timer, setTimer] =  useState(40);
  const { register, handleSubmit, watch, formState: {errors,isValid,},
  } = useForm<FormData>({resolver:zodResolver(schema), mode: "onChange", });
  const email =  watch("email");
  const codigo = watch("codigo") ?? "";
  /* ================================
     TIMER
  ================================ */

  useEffect(() => {
    if (!emailEnviado) return;
    if (timer === 0) return;
    const interval = setInterval(() => {
        setTimer((prev) => prev - 1);}, 1000);
    return () => clearInterval(interval); }, [
    emailEnviado, timer,]);

  /* ================================
     ENVIAR CÓDIGO
  ================================ */
  
  const onSubmit = async (data: FormData) => {
    setLoading(true);
    setErro("");
    try {
      await cognitoResetPassword(data.email);
      setEmailEnviado(true);
      setTimer(40);

    } catch ( error: any) {
      console.error(error);

      setErro("Erro ao enviar código de recuperação.");
    } finally {setLoading(false);}
  };

  /* ================================
     VALIDAR CÓDIGO
  ================================ */
const enviarCodigo = () => {

  navigate("/novasenha", {state: {codigo: codigo.trim(), email,}, });};

  /* ================================
     REENVIAR
  ================================ */

  const reenviar = async () => {
      if (!email) return;
      try {
        await cognitoResetPassword( email);
        setTimer(40);
      } catch (error) {console.error(error);}
    };
  return (
    <PageContainer icon={<Lock size={18} />}title="Recuperar Senha">
      <form className={styles.page} onSubmit={handleSubmit(onSubmit)}>
        <h4 className={ styles.titulo}>Esqueceu sua senha?</h4>
        <p className={styles.frase}> Não se preocupe. Digite seu e-mail e
          enviaremos um código para redefinir sua senha. </p>
        <label className={styles.labelEmail}>Email</label>
        <Input placeholder="seu@email.com" type="email" name="email"
          register={register}  error={errors.email?.message}
          customClass={styles.customInputMail} disabled={emailEnviado}/>
        {erro && (<p className={styles.error}>{erro}</p>)}
        {emailEnviado && (
          <p className={styles.sucesso}>
            Código enviado
            <span style={{ color:"green",}}>{" "} ✓ </span>
          </p>
        )}
        {emailEnviado && (
          <>
            <Input
              placeholder="Digite o código"
              type="text"
              name="codigo"
              register={register}
              customClass={styles.customInputClass}
            />
            <button type="button" className={styles.btnAvance}
              onClick={ enviarCodigo}>
              Continuar
            </button>
            {timer > 0 ? (
              <p className={styles.timer}>Reenviar código em{" "}
                {String(timer).padStart(2,"0")}s </p>
            ) : (
              <button type="button" className={styles.btnReenviar}
                onClick={reenviar}>
                Reenviar código
              </button>
            )}
          </>
        )}

        {!emailEnviado && (
          <button className={`${styles.btnAvance} ${
              !isValid ? styles.btnDisabled: ""}`} type="submit"
            disabled={loading || !isValid}>
            {loading? "Enviando...": "Enviar código"}
          </button>
        )}
        <div className={styles.containerDica}>
          <p className={styles.dica}>
            <strong>Dica:</strong>{" "}Verifique também sua caixa de spam.
          </p>
        </div>
      </form>
    </PageContainer>
  );
};